<div class="{{styles.loadingWrapper}}" style="width: {{typeof props.width === 'number' ? props.width + 'px' : props.width}}"><span class="{{styles.loading}}"><span class=""><i class="{{styles.loadingIcon}} iconfont icon-gengxin"></i></span> 加载中...</span></div>


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYFilter/loading.art